module.exports = __webpack_public_path__ + "static/img/60add.f8fe0dc8.png";